/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface InsuranceCompanyDetailsDtoOut
 */
export interface InsuranceCompanyDetailsDtoOut {
    /**
     * 
     * @type {string}
     * @memberof InsuranceCompanyDetailsDtoOut
     */
    code: InsuranceCompanyDetailsDtoOutCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof InsuranceCompanyDetailsDtoOut
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof InsuranceCompanyDetailsDtoOut
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InsuranceCompanyDetailsDtoOut
     */
    numericCode: number;
}

/**
    * @export
    * @enum {string}
    */
export enum InsuranceCompanyDetailsDtoOutCodeEnum {
    Vzp = 'VZP',
    Vozp = 'VOZP',
    Cpzp = 'CPZP',
    Ozp = 'OZP',
    Zps = 'ZPS',
    Zpmv = 'ZPMV',
    Rbp = 'RBP',
    Other = 'OTHER'
}



